import React, { useEffect, useState } from 'react'
import { hot } from 'react-hot-loader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import BottomBar from '../../../../components/BottomBar';
import BreadCrumb from '../../../../components/BreadCrumb';
import Container from '../../../../components/Container';
import PageTitle from '../../../../components/PageTitle';
import TitleBar from '../../../../components/TitleBar';
import { retrieveExperiment, retrieveFileInfo } from '../../../../sdk/apis';
import listDirectoryChildItems from '../../../../sdk/apis/listDirectoryChildItems';
import { addFolder, loadFolder } from '../../slice';
import { experimentRootUrl, fiscalYearExperimentsUrl, fiscalYearsUrl, folderContentsUrl } from '../../urls';
import { fisYear2Year } from '../FiscalYears/components/FiscalYearList';
import ContentsList from './components/ContentsList';

const FolderContents = () => {
  // useParamsを用いてurlsから変数1を取得
  const { year, ex_id, f_id } = useParams();
  const fiscalYear = parseInt(year);
  const experimentId = parseInt(ex_id);
  const folderId = parseInt(f_id);

  // useStateの作成
  const [experimentInfo, setExperimentInfo] = useState(null);
  const [folderInfo, setFolderInfo] = useState(null);
  const [folderContents, setForderContents] = useState(null);

  const folders = useSelector((state) => state.viewer.folders);
  const dispatch = useDispatch();

  useEffect(() => {
    listDirectoryChildItems(folderId).then((data) => {
      setForderContents(data);
    });
  }, [folderId]);

  // 実験名の取得
  if (experimentInfo === null) {
    retrieveExperiment(experimentId).then((data) => {
      setExperimentInfo(data)
    });

    return null;
  };

  // フォルダ情報の取得
  if (folderInfo === null || folderInfo.id !== folderId) {
    retrieveFileInfo(folderId).then((data) => {
      setFolderInfo(data)
      addFolder(data);
    });

    return null;
  }

  // フォルダの子要素情報の取得
  if (folderContents === null) {
    listDirectoryChildItems(folderId).then((data) => {
      setForderContents(data);
    });

    return null;
  }

  // パンくずリスト
  const breadcrumbData = [];
  breadcrumbData.push({ title: '実験一覧', url: fiscalYearsUrl(year) });
  breadcrumbData.push({ title: fisYear2Year(fiscalYear), url: fiscalYearExperimentsUrl(year, ex_id) });
  breadcrumbData.push({ title: experimentInfo.caption, url: experimentRootUrl(year, ex_id) });

  let f = folderInfo;
  const fData = [];
  fData.push(f);
  while (f.parent_id !== null) {
    if (f.parent_id in folders) {
      f = folders[f.parent_id];
      fData.splice(0, 0, f)
    } else {
      dispatch(loadFolder(f.parent_id));
      return null;
    }
  }
  for (let i = 0; i < fData.length; ++i) {
    const f = fData[i];
    if (i === fData.length - 1) {
      breadcrumbData.push({ title: f.name });
    } else {
      breadcrumbData.push({ title: f.name, url: folderContentsUrl(year, ex_id, f.id) });
    }
  }


  return (
    <>
      <TitleBar />
      <Container>
        <BreadCrumb data={breadcrumbData} />
        <PageTitle>{folderInfo.name}</PageTitle>
        <ContentsList experiment={experimentInfo} contents={folderContents} />
        <br></br>
      </Container>
      <BottomBar />
    </>
  );
};

export default FolderContents;
